<div class="detail-container">
  <form [formGroup]="emailTemplateForm" #form="ngForm">
    <div class="section container-fluid col-md-11 justify-content-center" fxLayoutGap="grid">
      <div class="innertitletxt">
        Template Email :
        <span *ngIf="isUpdateMode"> modification</span>
        <span *ngIf="!isUpdateMode"> création</span>
      </div>

      <div class="card">
        <div class="card-body">
          <div fxLayout="column" fxFlex="100" fxLayoutAlign="start">
            <div fxLayout="row" fxFlex="100" fxLayoutGap="10px">
              <div fxFlex="40" fxFlex.gt-sm="40" class="dropDownStyle">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Type * </mat-label>
                  <input matInput hidden readonly>
                  <ng-multiselect-dropdown [settings]="typeDropdownSettings" [data]="typeDropdownListData" required placeholder='Sélectionner...' [(ngModel)]="typeSelectedItems"
                    formControlName="TypeId" [ngClass]="{ 'is-invalid': submitted && emailTemplateForm.errors }" (onSelect)="onSelectTemplateType('select')"
                    (onDeSelect)="onSelectTemplateType('deselect')" ngDefaultControl required>
                  </ng-multiselect-dropdown>
                </mat-form-field>
              </div>
              <div fxFlex="60" fxFlex.gt-sm="60">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Label </mat-label>
                  <input matInput formControlName="Label" type="text" required>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row" fxFlex="100" fxLayoutGap="10px">
              <div fxFlex="40" fxFlex.gt-sm="40">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Objet </mat-label>
                  <input matInput formControlName="Title" type="text" required>
                </mat-form-field>
              </div>
              <div fxFlex="60" fxFlex.gt-sm="60">

              </div>
            </div>
            <div fxLayout="row" fxFlex="100">
              <mat-form-field floatLabel="always" appearance="outline">
                <mat-label>Contenu du template </mat-label>
                <input matInput hidden readonly>
                <div [hidden]="false" class="mail-display-content">
                  <app-rich-text-editor [content]="emailTemplateModel?.Content" [styles]="{height: '253px'}" (onContentChanged)="onContentChanged($event)"></app-rich-text-editor>
                </div>
              </mat-form-field>
            </div>
            <div fxLayout="row" fxFlex="100">
              <div class="card-body">
                <app-markers [dynamicPortalUrlMarkerIsMandatory]="dynamicPortalUrlMarkerIsMandatory" [dynamicAccessCodeMarkerIsMandatory]="dynamicAccessCodeMarkerIsMandatory"
                  [dynamicReasonsMarker]="dynamicReasonsMarker" [dynamicPortalUrlMarker]="dynamicPortalUrlMarker" [dynamicAccessCodeMarker]="dynamicAccessCodeMarker"
                  [dynamicReasonsMarkerFound]="dynamicReasonsMarkerFound" [dynamicPortalUrlMarkerFound]="dynamicPortalUrlMarkerFound" [dynamicAccessCodeMarkerFound]="dynamicAccessCodeMarkerFound">
                </app-markers>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div fxLayout=”row” fxLayoutAlign="end" class="bottom-bar">
      <div fxLayout=”row” fxLayoutAlign="end">
        <div class="btnSpacerCol">
          <button mat-stroked-button class="currentBtn" matTooltip="Annuler" (click)="onCancel()">
            <mat-icon>cancel</mat-icon>
            <span class="long-btn-span" fxHide fxShow.gt-md>Annuler</span>
          </button>
        </div>
        <div class="btnSpacerCol" *ngIf="isUpdateMode">
          <button mat-stroked-button class="currentBtn" matTooltip="Supprimer" (click)="onDelete()">
            <mat-icon>delete</mat-icon>
            <span class="long-btn-span" fxHide fxShow.gt-md>Supprimer</span>
          </button>
        </div>
        <div class="btnSpacerCol" *ngIf="isUpdateMode">
          <button mat-stroked-button class="currentBtnColor" matTooltip="Modifier" (click)="onSubmit()" [disabled]="!emailTemplateForm.valid || !AreMarkersValid">
            <mat-icon>save</mat-icon>
            <span class="long-btn-span" fxHide fxShow.gt-md>Enregistrer</span>
          </button>
        </div>
        <div class="btnSpacerCol" *ngIf="!isUpdateMode">
          <button mat-stroked-button class="currentBtnColor" matTooltip="Ajouter" (click)="onSubmit()" [disabled]="!emailTemplateForm.valid || !AreMarkersValid">
            <mat-icon>save</mat-icon>
            <span class="long-btn-span" fxHide fxShow.gt-md>Ajouter</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
